import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, isInvalid, Field } from 'redux-form'
import { FORM_LISTADO_MOVIMIENTOS_MERCADERIA } from '../../../../../config/forms'
import * as actions from '../actions/TablaMovimientosMercaderiaActions'
import {
  renderDateMaterialField
} from '../../../../Forms/fieldRenderers'
import Grid from '@material-ui/core/Grid'
import { Row, Col, Button } from 'react-bootstrap'

class FormMovimientosMercaderia extends Component {
  render () {
    const {
      handleSubmit,
      invalid
    } = this.props

    return (
      <div>
        <form onSubmit={handleSubmit}>
          <Row>
            <Col md={12}>
              <h4>Seleccione fechas de búsqueda</h4>
            </Col>
          </Row>
          <Row>
            <Col md={3} />
            <Col md={6}>
              <Grid container justify='space-around'>
                <Field
                  autoOk
                  name='fechaD'
                  emptyLabel
                  component={renderDateMaterialField}
                  value={new Date()}
                  autoFocus={false}
                  helperText='Fecha desde'
                  disableFuture
                  placeholder={``}
                  showTodayButton
                  todayLabel='Hoy'
                />
                <Field
                  autoOk
                  name='fechaH'
                  emptyLabel
                  component={renderDateMaterialField}
                  value={new Date()}
                  autoFocus={false}
                  helperText='Fecha hasta'
                  disableFuture
                  placeholder={``}
                  showTodayButton
                  todayLabel='Hoy'
                />
              </Grid>
            </Col>
            <Col md={3} />
          </Row>
          <Row>
            <Col md={12}>
              <Button
                type='submit'
                disabled={invalid}
                size='lg'
              >Consultar</Button>
            </Col>
          </Row>
        </form>
      </div>
    )
  };
};

const mapStateToProps = (state) => ({
  invalid: isInvalid(FORM_LISTADO_MOVIMIENTOS_MERCADERIA)(state)
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_LISTADO_MOVIMIENTOS_MERCADERIA,
  destroyOnUnmount: false
})

export default withRedux(withReduxForm(FormMovimientosMercaderia))
